import React from 'react';
import Grid from '@mui/material/Grid';
import { Box, CircularProgress, Typography } from '@mui/material';
import DataTable from 'widgets/datagrid/DataTable';

export function RenderLoader() {
  return (
    <Box display='flex' alignItems='center' justifyContent='center' minHeight='300px'>
      <CircularProgress />
    </Box>
  );
}

export function RenderTable({
  mappedRows,
  Columns,
  handleRowClick,
  page,
  size,
  pagination,
  getBackgroundColor,
  loading,
}) {
  return (
    <Grid paddingRight={5} paddingLeft={0}>
      <Box sx={{ height: '67vh' }}>
        <DataTable
          rows={mappedRows}
          columns={Columns}
          onRowClick={handleRowClick}
          page={page}
          pageSize={size}
          rowCount={pagination?.total_rows ?? 0}
          onPageChange={pagination?.handleChangePage}
          handleChangePageSize={pagination?.handleChangePageSize}
          getBackgroundColor={getBackgroundColor}
          mappedRows={mappedRows}
          loading={loading}
        />
      </Box>
    </Grid>
  );
}

export function RenderNoRecords() {
  return <Typography variant='h6'>No hay registros disponibles</Typography>;
}
